<template>
  <div class="explore-loader-local">
    <div class="loader-content">
      <v-progress-circular
        indeterminate
        color="#8e84c0"
        size="50"
        width="2"
        class="loader-spinner"
      >
        <v-img
          :src="Logo"
          height="28px"
          width="28px"
          class="loader-logo"
        />
      </v-progress-circular>
    </div>
  </div>
</template>

<script>
import Logo from "@/assets/logo/1-10.webp";

export default {
  name: "ExploreLoader",
  data() {
    return {
      Logo,
    };
  },
};
</script>

<style scoped>
.explore-loader-local {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(26, 26, 46, 0.75);
  z-index: 9999;
  opacity: 0.85;
}

.loader-content {
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.95;
}

.loader-spinner {
  opacity: 0.95;
}

.loader-logo {
  opacity: 1;
  filter: drop-shadow(0 0 4px rgba(142, 132, 192, 0.3));
}
</style>
